import { useFormBuilderWithConsent } from '@gov-nx/core/service';
import type { PPPStep3Fields, PPPStep3FormData } from './formSteps.types';

export const useFormStep3 = (
	isDisabled: boolean,
	isLowAuthorization: boolean
) =>
	useFormBuilderWithConsent<PPPStep3Fields, PPPStep3FormData>([], {
		isDisabled,
		isLowAuthorization,
	});
